import React, { useState, useEffect, useCallback } from 'react';
import '../styles/AchievementNotification.css';

const AchievementNotification = ({ achievement, onClose }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isLeaving, setIsLeaving] = useState(false);

  const handleClose = useCallback(() => {
    setIsLeaving(true);
    setTimeout(() => {
      setIsVisible(false);
      if (onClose) onClose();
    }, 300);
  }, [onClose]);

  useEffect(() => {
    if (achievement) {
      // Reset states
      setIsVisible(false);
      setIsLeaving(false);
      
      // Show the notification with a slight delay for smooth animation
      const showTimer = setTimeout(() => {
        setIsVisible(true);
      }, 100);
      
      // Auto-close after 5 seconds
      const autoCloseTimer = setTimeout(() => {
        setIsLeaving(true);
        setTimeout(() => {
          setIsVisible(false);
          if (onClose) onClose();
        }, 300);
      }, 5100); // 5 seconds + 100ms for show animation

      return () => {
        clearTimeout(showTimer);
        clearTimeout(autoCloseTimer);
      };
    }
  }, [achievement, onClose]);


  if (!achievement) return null;

  const getTierColor = (tier) => {
    switch (tier) {
      case 'bronze': return '#CD7F32';
      case 'silver': return '#C0C0C0';
      case 'gold': return '#FFD700';
      case 'platinum': return '#E5E4E2';
      default: return '#4CAF50';
    }
  };

  const getTierGlow = (tier) => {
    switch (tier) {
      case 'bronze': return '0 0 20px rgba(205, 127, 50, 0.6)';
      case 'silver': return '0 0 20px rgba(192, 192, 192, 0.6)';
      case 'gold': return '0 0 20px rgba(255, 215, 0, 0.6)';
      case 'platinum': return '0 0 20px rgba(229, 228, 226, 0.6)';
      default: return '0 0 20px rgba(76, 175, 80, 0.6)';
    }
  };

  return (
    <div className={`achievement-notification ${isVisible ? 'visible' : ''} ${isLeaving ? 'leaving' : ''}`}>
      <div className="achievement-notification-content">
        <div className="achievement-header">
          <div className="achievement-badge">
            <div 
              className="achievement-icon"
              style={{ 
                backgroundColor: getTierColor(achievement.tier),
                boxShadow: getTierGlow(achievement.tier)
              }}
            >
              {achievement.icon}
            </div>
            <div className="achievement-sparkles">
              <span className="sparkle sparkle-1">✨</span>
              <span className="sparkle sparkle-2">⭐</span>
              <span className="sparkle sparkle-3">✨</span>
            </div>
          </div>
          <button className="close-button" onClick={handleClose}>
            ×
          </button>
        </div>
        
        <div className="achievement-info">
          <div className="achievement-title">🏆 Achievement Unlocked!</div>
          <div className="achievement-name">{achievement.name}</div>
          <div className="achievement-description">{achievement.description}</div>
          {achievement.tier && (
            <div className="achievement-tier" style={{ color: getTierColor(achievement.tier) }}>
              {achievement.tier.charAt(0).toUpperCase() + achievement.tier.slice(1)} Tier
            </div>
          )}
          <div className="achievement-reward">
            +{achievement.pointsReward} points earned! 🎉
          </div>
        </div>
      </div>
    </div>
  );
};

export default AchievementNotification;